import { render, staticRenderFns } from "./Indiamart.vue?vue&type=template&id=9d7da6f0&scoped=true"
import script from "./Indiamart.vue?vue&type=script&lang=js"
export * from "./Indiamart.vue?vue&type=script&lang=js"
import style0 from "./Indiamart.vue?vue&type=style&index=0&id=9d7da6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7da6f0",
  null
  
)

export default component.exports